import moment from 'moment';

export const GetStartOfDay = (date) => {
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    return newDate;
};

export const withOutTimeZoneDate = (date) => {
    const newDate = moment(date);
    console.log('newDate',newDate);
    const tzoffset = newDate.utcOffset() * 60000;
    console.log('tzoffset',tzoffset);
    const withOutTimeZoneDate = moment(newDate.valueOf() - tzoffset).utc(true).toISOString().slice(0, -1);
    return withOutTimeZoneDate;
};